import { Button, ButtonProps } from "@mui/material";
import { useStylesCss } from "./AppButtons.styles";
import CircleButtonBig from "./CircleButtonBig";
import AppIconsArrow1 from "../AppIcons/AppIconsArrow1";

const FlowTopButton: React.FC<ButtonProps> = (props: ButtonProps) => {
  const classes = useStylesCss();
  const myClasses = { ...props.sx, ...classes.general };
  const myProps = {
    sx: myClasses,
    ...props,
  };
  return (
    
    <CircleButtonBig {...myProps}>
    <AppIconsArrow1 sx={{transform:"rotate(-90deg)"}}/>
  </CircleButtonBig>
  );
};
export default FlowTopButton;
